<template>
<div>

  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Logistic</el-breadcrumb-item>
    <el-breadcrumb-item>Cargo Management</el-breadcrumb-item>
  </el-breadcrumb>
  <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col> -->
  <!--卡片视图区域-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
      <!--IP user-->
      <div v-if="this.userName.toUpperCase()==='J3P'">
        <el-row>
          <el-col :span = "7">
      <el-form-item label="Customer Code:" label-width="135px">
        <!-- <el-input v-model="formInline.item" placeholder="Item" clearable></el-input> -->
        <el-select v-model="formInline.customerCode" collapse-tags clearable
              placeholder="please choose">
            <el-option
            v-for="item in this.customerBrands"
            :key="item.customerCode"
            :label="item.customerCode"
            :value="item.customerCode">
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      <el-col :span = "7">
        <el-form-item label="Item:" label-width="115px">
                  <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
                </el-form-item>
      </el-col>

      <!-- <el-col :span = "12">
        <el-form-item label="Delivery Address:" label-width="200px">
          <el-select v-model="formInline.deliveryAddr" multiple collapse-tags
                style="margin-left: 0px;"   filterable
                placeholder="please choose">
              <el-option
                v-for="item in this.deliveryAddrList"
                :key="item.code"
                :label="item.code"
                :value="item.code">
                <span style="float: left">{{ item.code }}</span>
                <span style="float: right; margin-right: 5px; color: #8492a6; font-size: 13px">{{ item.description }}</span>
              </el-option>
          </el-select>
        </el-form-item>
      </el-col> -->
      <el-col :span = "10">
        <el-form-item label="Final Delivery Address:" label-width="200px">
          <el-select v-model="formInline.finalDeliveryAddr" multiple collapse-tags
                style="margin-left: 0px;"   filterable
                placeholder="please choose">
              <el-option
                v-for="item in this.deliveryAddrList"
                :key="item"
                :label="item"
                :value="item">
                <!-- <span style="float: left">{{ item }}</span>
                <span style="float: right; margin-right: 5px; color: #8492a6; font-size: 13px">{{ item.description }}</span> -->
              </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <el-col :span = "10">
      <el-form-item   label="Approved:" label-width="115px">
        <el-switch
          style="display: block"
          v-model="formInline.approved"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Yes"
          inactive-text="No">
        </el-switch>
      </el-form-item>
      </el-col> -->
            </el-row>
      <el-row>
        <el-col :span = "7">
          <el-form-item label="Cargo ID:" label-width="135px">
            <el-select v-model="formInline.rglFileName" collapse-tags clearable allow-create filterable
                  placeholder="please choose">
                <el-option
                v-for="item in this.fglFileNameSelection"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
                </el-col>
          <el-col :span = "7">
                <el-form-item label="Description:" label-width="115px">
                  <el-input v-model="formInline.description" placeholder="Description" clearable></el-input>
                </el-form-item>
                </el-col>
                <el-col :span = "10">
                <el-form-item label="Final Incoterm Town:" label-width="200px">
                        <el-select v-model="formInline.finalIncotermCity" multiple collapse-tags
                              style="margin-left: 0px;"
                              placeholder="please choose">
                            <el-option
                            v-for="item in this.incotermCityList"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      </el-col>
                      </el-row>
                <!-- <el-col :span = "10">
                <el-form-item   label="Ship Out:" label-width="115px">
                  <el-switch
                    style="display: block"
                    v-model="formInline.shipOut"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Yes"
                    inactive-text="No">
                  </el-switch>
                </el-form-item>
                </el-col> -->
                  <!-- <el-col :span = "7">
                    <el-form-item label="Final Delivery Address:" label-width="200px">
                      <el-select v-model="formInline.finalDeliveryAddr" multiple collapse-tags
                            style="margin-left: 0px;"   filterable
                            placeholder="please choose">
                          <el-option
                            v-for="item in this.deliveryAddrList"
                            :key="item.code"
                            :label="item.code"
                            :value="item.code">
                            <span style="float: left">{{ item.code }}</span>
                            <span style="float: right; margin-right: 5px; color: #8492a6; font-size: 13px">{{ item.description }}</span>
                          </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span = "7">
                    <el-form-item   label="Ship Out:" label-width="135px">
                      <el-select v-model="formInline.shipOut" collapse-tags
                      placeholder="please choose">
                          <el-option
                          v-for="item in this.approvedValues"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    </el-col>
                  <!-- <el-col :span = "7">
                  <el-form-item   label="Approved:" label-width="135px">
                    <el-select v-model="formInline.approved" collapse-tags
                    placeholder="please choose">
                        <el-option
                        v-for="item in this.approvedValues"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  </el-col> -->
                <el-col :span = "7">
                      <el-form-item label="SRF:" label-width="115px">
                        <el-input v-model="formInline.srf" placeholder="if search blank,type blank" clearable></el-input>
                      </el-form-item>
                      </el-col>
                <el-col :span = "10">
                <el-form-item   label="Approved:" label-width="200px">
                  <el-select v-model="formInline.approved" collapse-tags
                  placeholder="please choose">
                      <el-option
                      v-for="item in this.approvedValues"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                  <el-col :span = "20">
                  <el-form-item style="margin-left: 470px;">
                    <el-button type="primary" @click="onSubmit">Search</el-button>
                    <el-button type="primary" @click="exportToExcel">Excel</el-button>
                  </el-form-item>
                  </el-col>
                </el-row>
      </div>

      <div v-else>
        <el-row>
          <el-col :span = "10">
          <el-form-item label="Cargo ID:"  label-width="200px">
            <el-select v-model="formInline.rglFileName" collapse-tags clearable allow-create filterable
                  placeholder="please choose">
                <el-option
                v-for="item in this.fglFileNameSelection"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span = "6">
            <el-form-item label="Item:" label-width="50px">
                      <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
                    </el-form-item>
                  </el-col>
<el-col :span = "7">
                <el-form-item label="Description:" label-width="115px">
                  <el-input v-model="formInline.description" placeholder="Description" clearable></el-input>
                </el-form-item>
                </el-col>
              </el-row>
        <el-row>
          <el-col :span = "10">
            <el-form-item label="Final Delivery Address:" label-width="200px">
              <el-select v-model="formInline.finalDeliveryAddr" multiple collapse-tags
                    style="margin-left: 0px;"   filterable
                    placeholder="please choose">
                  <el-option
                    v-for="item in this.deliveryAddrList"
                    :key="item"
                    :label="item"
                    :value="item">
                    <!-- <span style="float: left">{{ item }}</span>
                    <span style="float: right; margin-right: 5px; color: #8492a6; font-size: 13px">{{ item.description }}</span> -->
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span = "6">
      <el-form-item   label="Approved:"  label-width="70px">
        <el-select v-model="formInline.approved" collapse-tags
        placeholder="please choose">
            <el-option
            v-for="item in this.approvedValues"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col>
        <el-form-item style="margin-left: 500px;">
          <el-button type="primary" @click="onSubmit">Search</el-button>
          <el-button type="primary" @click="exportToExcel">Excel</el-button>
        </el-form-item>
        </el-col>
      </el-row>
      </div>
    </el-form>
    <el-dialog :title="'Cargo ID: ' + this.currRglName"
      width="89%" :visible.sync="dialogFormVisible">
      <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT'" style="margin-bottom: 10px;margin-top: 10px" type="primary" @click="addRfqRow">Add new</el-button>
      <el-tag style="margin-bottom: 10px;margin-left: 10px;"><span style="font-size:10px;">Net CBM:</span>{{ this.netCbm }} ,&nbsp; Gross CBM:{{ this.grossCbm }},&nbsp; Total Carton:{{ this.totalCarton }},&nbsp; Total NW:{{ Math.round(this.totalNW * 100) / 100 }},&nbsp; Total GW:{{ Math.round(this.totalGW * 100) / 100 }},&nbsp;  Total Sch.Q:{{ this.totalSchQ }},&nbsp;  SRF:{{ this.srf}},&nbsp;  Comment:{{ this.comment}}</el-tag>
      <!-- Schedule 列表区域 -->
      <!-- <el-button style="margin-bottom: 10px;" type="primary" @click="addRfqRow">Add new</el-button> -->
      <el-table :data="this.multipleSelection" border stripe style="width: 100%">
            <el-table-column type="index" label="#"></el-table-column>
            <el-table-column property="status" label="Status" width="95">
              <template slot-scope="scope">
              <el-select v-model="scope.row.status"  collapse-tags clearable v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                    style="margin-left: 0px;"   size="mini"
                    placeholder="please choose">
                  <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.status}}</div>
                </template>
            </el-table-column>
            <el-table-column property="schSeq" label="Sch. Seq" width="100"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-select v-model="scope.row.schSeq" v-if="scope.row.flag==='add'" default-first-option size="mini">
                <el-option
                  v-for="item in schSeqArr"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
                </el-select>
              <div  v-if="scope.row.flag==='view' || scope.row.flag==='edit'">{{scope.row.schSeq}}</div>
              </template>
            </el-table-column>
            <el-table-column property="schDate" label="Sch Date" width="120"   :formatter="dateFormat">
              <template slot-scope="scope">
                      <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                        v-model="scope.row.schDate"   size="mini" value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="Sch Date">
                      </el-date-picker>
                      <div  v-if="scope.row.flag==='view'">{{ dateFormat1(scope.row.schDate) }}</div>
                      </template>
            </el-table-column>
            <el-table-column property="schQ" label="Sch. Q" width="100"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.schQ" size="mini" @blur="checkInteger($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.schQ}}</div>
              </template>
            </el-table-column>
            <el-table-column property="supplier" label="Supplier" width="100" :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.supplier" size="mini"></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.supplier}}</div>
              </template>
            </el-table-column>
            <el-table-column property="intnlRef" label="Internal reference" width="170"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.intnlRef" size="mini" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.intnlRef}}</div>
              </template>
            </el-table-column>
            <el-table-column property="item" label="Item" width="120"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.item" size="mini" @blur="checkItemNumber($event)" :data-id="scope.row.idx" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view' || scope.row.flag==='edit'">{{scope.row.item}}</div>
              </template>
            </el-table-column>
            <el-table-column property="itemDesc" label="Item Description" width="139"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.itemDesc" size="mini" maxlength=250></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.itemDesc}}</div>
              </template>
            </el-table-column>
            <el-table-column property="brand" label="Brand" width="100"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-select v-model="scope.row.brand"  collapse-tags  size="mini"
                      style="margin-left: 0px;"  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in brandList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              <!-- <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.soldTo" size="mini" maxlength=50></el-input> -->
              <div  v-if="scope.row.flag==='view'">{{scope.row.brand}}</div>
              </template>
            </el-table-column>

            <el-table-column property="length" label="Length" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.length" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.length}}</div>
              </template>
            </el-table-column>
            <el-table-column property="width" label="Width" width="80">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.width" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.width}}</div>
              </template>
            </el-table-column>
            <el-table-column property="height" label="Height" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.height" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.height}}</div>
              </template>
            </el-table-column>
            <el-table-column property="carton" label="Carton" width="90" :formatter="numFormat">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.carton" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.carton}}</div>
              </template>
            </el-table-column>
            <el-table-column property="nw" label="NW" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.nw" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.nw}}</div>
              </template>
            </el-table-column>
            <el-table-column property="gw" label="GW" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.gw" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.gw}}</div>
              </template>
            </el-table-column>
            <el-table-column property="volumn" label="Volume (CBM)" width="110">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.volumn" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.volumn}}</div>
              </template>
            </el-table-column>
            <el-table-column property="soldTo" label="Sold to" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.soldTo"  collapse-tags  size="mini"
                      style="margin-left: 0px;"  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in soldToArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              <!-- <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.soldTo" size="mini" maxlength=50></el-input> -->
              <div  v-if="scope.row.flag==='view'">{{scope.row.soldTo}}</div>
              </template>
            </el-table-column>
            <el-table-column property="deliveryAddr" label="Delivery address" width="130">
              <template slot-scope="scope">
                <el-select v-model="scope.row.deliveryAddr" v-if="scope.row.flag==='add' || scope.row.flag==='edit'"  collapse-tags size="mini"
                      style="margin-left: 0px;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in deliveryAddrList"
                    :key="item"
                    :label="item"
                    :value="item">
                    <!-- <span style="float: left">{{ item.description }}</span>
                    <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.code }}</span> -->
                  </el-option>
                </el-select>
              <!-- <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.deliveryAddr" size="mini" maxlength=50></el-input> -->
              <div  v-if="scope.row.flag==='view'">{{scope.row.deliveryAddr}}</div>
              </template>
            </el-table-column>
            <el-table-column property="incotermCity" label="Incoterm City" width="136">
              <template slot-scope="scope">
                <el-select v-model="scope.row.incotermCity" v-if="scope.row.flag==='add' || scope.row.flag==='edit'"  collapse-tags size="mini"
                        style="margin-left: 0px;"
                        placeholder="please choose">
                      <el-option
                      v-for="item in incotermCityList"
                      :key="item"
                      :label="item"
                      :value="item">
                      <!-- <span style="float: left">{{ item.description }}</span>
                      <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.code }}</span> -->
                    </el-option>
                  </el-select>
                <!-- <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.deliveryAddr" size="mini" maxlength=50></el-input> -->
                <div  v-if="scope.row.flag==='view'">{{scope.row.incotermCity}}</div>
              <!-- <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.incotermCity" size="mini" maxlength=50></el-input> -->
              <!-- <div>{{scope.row.incotermCity}}</div> -->
              </template>
            </el-table-column>
                <el-table-column label="operation" width="170" v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT'">
                  <template slot-scope="scope">
                    <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT' && scope.row.flag==='view'" type="info" plain size="mini" @click="editRfqRow(scope.row.id)">Edit</el-button>
                    <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT' && scope.row.flag==='add'" type="info" plain size="mini" @click="addRfqRow2Db(scope.row)">Add</el-button>
                    <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT' && scope.row.flag==='edit'" type="info" plain size="mini" @click="updateRfqRow2Db(scope.row)">Update</el-button>
                    <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT'" type="info" plain size="mini" @click="delRfqRow2Db(scope.row)">Delete</el-button>
                    </template>
                </el-table-column>
          </el-table>
          </el-dialog>

      <!-- CRProject 列表区域 -->
      <el-table :data="this.rglData" border stripe style="width: 100%">
        <el-table-column type="index" label="#"  fixed></el-table-column>
        <el-table-column  fixed
          prop="rglFileName"
          label="Cargo ID"
          width="160">
        </el-table-column>
        <el-table-column fixed property="srf" label="SRF" width="160" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.srf" size="mini"></el-input>
            <div v-if="scope.row.flag==='view'">{{scope.row.srf}}</div>
          </template>
        </el-table-column>
<!--        <el-table-column  fixed-->
<!--          prop="mergedSoldTo"  :show-overflow-tooltip="true"-->
<!--          label="Sold To"-->
<!--          width="105">-->
<!--        </el-table-column>-->
        <el-table-column
                          prop="mergedSoldTo"  :show-overflow-tooltip="true"
                          label="Sold To"
                          width="105">
        </el-table-column>
        <el-table-column property="netCbm " label="Net CBM" width="105">
          <template slot-scope="scope">
          <div>{{scope.row.netCbm}}</div>
          </template>
        </el-table-column>
        <el-table-column property="grossCbm" label="Gross CBM" width="105">
          <template slot-scope="scope">
          <div>{{scope.row.grossCbm}}</div>
          </template>
        </el-table-column>
<!--        <el-table-column property="srf" label="SRF" width="105" :show-overflow-tooltip="true">-->
<!--          <template slot-scope="scope">-->
<!--          <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.srf" size="mini"></el-input>-->
<!--          <div v-if="scope.row.flag==='view'">{{scope.row.srf}}</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column property="cargoReadyDate" label="Cargo Ready Date" width="127">
          <template slot-scope="scope">
                  <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                    v-model="scope.row.cargoReadyDate" value-format="yyyy-MM-dd" size="mini"
                    type="date"
                    placeholder="Cargo Ready Date">
                  </el-date-picker>
                  <div  v-if="scope.row.flag==='view'">{{dateFormat1(scope.row.cargoReadyDate) }}</div>
                  </template>
        </el-table-column>
        <el-table-column property="SRFAppDate" label="SRF Application Date" width="155">
                  <template slot-scope="scope">
                          <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                            v-model="scope.row.SRFAppDate" value-format="yyyy-MM-dd" size="mini"
                            type="date"
                            placeholder="SRF Application Date">
                          </el-date-picker>
                          <div  v-if="scope.row.flag==='view'">{{dateFormat1(scope.row.SRFAppDate) }}</div>
                          </template>
                </el-table-column>
                <el-table-column property="container" label="Container" width="110">
                  <template slot-scope="scope">
                    <!-- <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.container"  size="mini"></el-input>
                    <div v-if="scope.row.flag==='view'">{{ scope.row.container }}</div> -->
                    <div>{{ scope.row.container }}</div>
                  </template>
                </el-table-column>
                <el-table-column property="etd" label="ETD" width="110">
                  <template slot-scope="scope">
                          <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                            v-model="scope.row.etd" value-format="yyyy-MM-dd" size="mini"
                            type="date"
                            placeholder="ETD">
                          </el-date-picker>
                          <div  v-if="scope.row.flag==='view'">{{ dateFormat1(scope.row.etd) }}</div>
                          </template>
                </el-table-column>
                <el-table-column property="eta" label="ETA" width="110"   :formatter="dateFormat">
                  <template slot-scope="scope">
                          <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                            v-model="scope.row.eta" value-format="yyyy-MM-dd" size="mini"
                            type="date"
                            placeholder="ETA">
                          </el-date-picker>
                          <div  v-if="scope.row.flag==='view'">{{dateFormat1(scope.row.eta) }}</div>
                          </template>
                </el-table-column>
            <el-table-column property="freightCost" label="Freight Cost" width="105"   :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'"  v-model="scope.row.freightCost"  @blur="checkNum($event)" size="mini"></el-input>
              <div v-if="scope.row.flag==='view'">{{ zeroFormat(scope.row.freightCost) }}</div>
              </template>
            </el-table-column>
            <el-table-column property="freightForwName" label="Freight Forwarder" width="135" :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.freightForwName" size="mini"></el-input>
              <div v-if="scope.row.flag==='view'">{{scope.row.freightForwName}}</div>
              </template>
            </el-table-column>
            <el-table-column property="palletNum" label="Number of Pallets" width="135">
              <template slot-scope="scope">
              <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.palletNum" @blur="checkInteger($event)" size="mini"></el-input>
              <div v-if="scope.row.flag==='view'">{{ zeroFormat(scope.row.palletNum) }}</div>
              </template>
            </el-table-column>
            <el-table-column property="cartonsNoPallet" label="Carton without Pallets" width="176">
              <template slot-scope="scope">
                <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.cartonsNoPallet" @blur="checkInteger($event)" size="mini"></el-input>
                <div v-if="scope.row.flag==='view'">{{ zeroFormat(scope.row.cartonsNoPallet) }}</div>
              </template>
            </el-table-column>
            <el-table-column property="currency" label="Currency" width="95">
              <template slot-scope="scope">
              <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.currency"  size="mini" placeholder="Please choose">
                <el-option
                  v-for="item in currencyArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.currency}}</div>
                </template>
            </el-table-column>
             <el-table-column property="approval" label="Approval" width="96">
               <template slot-scope="scope">
                <el-switch v-if="scope.row.flag==='add' || scope.row.flag==='edit'" size="mini"
                  style="display: block"
                  v-model="scope.row.approval"    @change="approvalChange(scope.row, scope.$index)"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="Yes"
                  inactive-text="No">
                </el-switch>
                <div  v-if="scope.row.flag==='view'">{{scope.row.approval}}</div>
                </template>
              </el-table-column>
              <el-table-column property="approvalDate" label="Approval Date" width="110">
                <template slot-scope="scope">
                        <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                          v-model="scope.row.approvalDate" value-format="yyyy-MM-dd" size="mini"
                          type="date"     :disabled="isDisabled[scope.$index]"
                          placeholder="Approval Date">
                        </el-date-picker>
                        <div  v-if="scope.row.flag==='view'">{{ dateFormat1(scope.row.approvalDate) }}</div>
                        </template>
              </el-table-column>
              <el-table-column property="shipOut" label="Ship Out" width="96">
                <template slot-scope="scope">
                 <el-switch v-if="scope.row.flag==='add' || scope.row.flag==='edit'" size="mini"
                   style="display: block"
                   v-model="scope.row.shipOut"
                   active-color="#13ce66"
                   inactive-color="#ff4949"
                   active-text="Yes"
                   inactive-text="No">
                 </el-switch>
                 <div  v-if="scope.row.flag==='view'">{{scope.row.shipOut}}</div>
                 </template>
               </el-table-column>
              <el-table-column property="packingListNbr" label="Packing List" width="106">
                <template slot-scope="scope">
                <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.packingListNbr" collapse-tags
                      style="margin-left: 0px;" filterable size="mini" clearable
                      placeholder="please choose">
                    <el-option
                    v-for="item in packingList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.packingListNbr}}</div>
                </template>
                </el-table-column>
                <el-table-column property="finalDeliveryAddr" label="Final Delivery Addr" width="160">
                  <template slot-scope="scope">
                  <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.finalDeliveryAddr" collapse-tags
                        style="margin-left: 0px;"  size="mini" allow-create filterable
                        placeholder="please choose">
                      <el-option
                      v-for="item in finalDeliveryAddrList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                  <div  v-if="scope.row.flag==='view'">{{scope.row.finalDeliveryAddr}}</div>
                  </template>
                  </el-table-column>
                  <el-table-column property="finalIncotermCity" label="Final Incoterm City" width="160">
                    <template slot-scope="scope">
                    <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.finalIncotermCity" collapse-tags
                          style="margin-left: 0px;" filterable size="mini"
                          placeholder="please choose">
                        <el-option
                        v-for="item in finalIncotermCityList"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                    <div  v-if="scope.row.flag==='view'">{{scope.row.finalIncotermCity}}</div>
                    </template>
                    </el-table-column>

                <el-table-column property="comment" label="Comment" width="110"  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.comment"  size="mini"></el-input>
                    <div v-if="scope.row.flag==='view'">{{ scope.row.comment }}</div>
                  </template>
                </el-table-column>
            <el-table-column label="operation" width="222">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.flag==='view' " type="info" plain size="mini" @click="viewRfqFile(scope.row.rglFileName, scope.row.srf, scope.row.comment)">View</el-button>
                      <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT' && scope.row.flag==='view'" type="info" plain size="mini" @click="editRfqTblRow(scope.row, scope.$index)">Edit</el-button>
                      <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT' && scope.row.flag==='edit'" type="info" plain size="mini" @click="updateRfqTblRow2Db(scope.row)">Update</el-button>
                      <el-button v-if="userName.toUpperCase()!=='IP' && userName.toUpperCase()!=='IPIT'" type="info" plain size="mini" @click="delRfqTbl2Db(scope.row.rglFileName)">Delete</el-button>
                      </template>
                  </el-table-column>
            </el-table>

          <!-- 分页区域-->
           <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination> -->
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        customerCode: '',
        rglFileName: '',
        item: '',
        finalDeliveryAddr: [],
        finalIncotermCity: [],
        description: '',
        srf: '',
        approved: 'All',
        shipOut: 'No'
      },
      userName: '',
      rglData: [],
      fglFileNameList: [],
      packingList: [],
      fglFileNameSelection: [],
      total: 0,
      updateTime: '',
      isDisabled: [false],
      approvedValues: ['Yes', 'No', 'All'],
      currencyArr: [{
        value: 'USD',
        label: 'USD'
      }, {
        value: 'EUR',
        label: 'EUR'
      }, {
        value: 'RMB',
        label: 'RMB'
      }],
      schSeqArr: ['Sch. 1', 'Sch. 2', 'Sch. 3', 'Sch. 4'],
      statusArr: [{
        value: 'DEV',
        label: 'Development',
        description: 'Development'
      }, {
        value: 'HLD',
        label: 'On Hold',
        description: 'On Hold'
      }, {
        value: 'LHK',
        label: 'Loading Hong Kong',
        description: 'Loading Hong Kong'
      }, {
        value: 'LSH',
        label: 'Loading Shanghai',
        description: 'Loading Shanghai'
      }, {
        value: 'LXI',
        label: 'Loading Xiamen',
        description: 'Loading Xiamen'
      }, {
        value: 'LYA',
        label: 'Loading Yantian',
        description: 'Loading Yantian'
      }, {
        value: 'NEW',
        label: 'New Order',
        description: 'New Order'
      }, {
        value: 'OKC',
        label: 'Confirmed to Close on arrival',
        description: 'Confirmed to Close on arrival'
      }, {
        value: 'OLO',
        label: 'On Line QC Pass',
        description: 'On Line QC Pass'
      }, {
        value: 'ONG',
        label: 'On Going Production',
        description: 'On Going Production'
      }, {
        value: 'PND',
        label: 'Pending for Approval',
        description: 'Pending for Approval'
      }, {
        value: 'PNO',
        label: 'Produce with Next Order',
        description: 'Produce with Next Order'
      }, {
        value: 'REJ',
        label: 'Reject',
        description: 'Reject'
      }, {
        value: 'RHK',
        label: 'Ready Hong Kong',
        description: 'Ready Hong Kong'
      }, {
        value: 'RSH',
        label: ' Ready Shanghai',
        description: ' Ready Shanghai'
      }, {
        value: 'RTC',
        label: 'Request to Close',
        description: 'Request to Close'
      }, {
        value: 'RXI',
        label: 'Ready Xiamen',
        description: 'Ready Xiamen'
      }, {
        value: 'RYA',
        label: 'Ready Yantian',
        description: 'Ready Yantian'
      }, {
        value: 'SFR',
        label: 'Shipment ready from France',
        description: 'Shipment ready from France'
      }, {
        value: 'SME',
        label: 'Shipment ready from Mexico',
        description: 'Shipment ready from Mexico'
      }, {
        value: 'TLB',
        label: 'Ready for Transfer to LB',
        description: 'Ready for Transfer to LB'
      }, {
        value: 'TYF',
        label: 'Ready for Transfer to Yufan',
        description: 'Ready for Transfer to Yufan'
      }, {
        value: 'WFC',
        label: 'Waiting for confirmation',
        description: 'Waiting for confirmation'
      }
      ],
      customerBrands: [{
        customerCode: 'BUBBLE',
        brandCode: ['BUBBLE']
      }, {
        customerCode: 'CSP',
        brandCode: ['CSP']
      }, {
        customerCode: 'DERA',
        brandCode: ['PION']
      }, {
        customerCode: 'EC',
        brandCode: ['EC']
      }, {
        customerCode: 'ELLA',
        brandCode: ['ELLA']
      }, {
        customerCode: 'HBG',
        brandCode: ['B&M', 'BJ', 'BM', 'CANDIES', 'Jones', 'JOR', 'MJ', 'PMF', 'TAHARI']
      }, {
        customerCode: 'IP',
        brandCode: ['AF', 'AP', 'AS', 'BB', 'BEBE', 'DKNY', 'DUN', 'FC', 'FCUK', 'GRAFF', 'GUESS', 'HOL', 'JPF', 'MCM', 'MULTI', 'ODLR', 'TJMAXX']
      }, {
        customerCode: 'IPIT',
        brandCode: ['FER', 'UNG']
      }, {
        customerCode: 'JEN',
        brandCode: ['JEN']
      }, {
        customerCode: 'NPS',
        brandCode: ['BRANDFREE']
      }, {
        customerCode: 'OMC',
        brandCode: ['OMC']
      }, {
        customerCode: 'OWILD',
        brandCode: ['OWILD']
      }, {
        customerCode: 'SIK',
        brandCode: ['SIK']
      }, {
        customerCode: 'SDPP',
        brandCode: ['GUESS', 'MCM']
      }, {
        customerCode: 'TSM',
        brandCode: ['TSM BRANDS']
      }],
      soldToArr: ['IP', 'OMC', 'CSP', 'HORIZONB', 'OWILD', 'SDPP', 'JEN', 'LASH', 'TSM', 'OSEE', 'BUBBLE', 'GOTHA', 'TSMT', 'SAP', 'DIJO', 'TBY', 'EXERTIER', 'NPS', 'HERON', 'J3P', 'PPI', 'ESF', 'IPIT'],
      netCbm: 0,
      grossCbm: 0,
      totalCarton: 0,
      totalNW: 0,
      totalGW: 0,
      totalSchQ: 0,
      multipleSelection: [],
      oldVolumn: [],
      oldCarton: [],
      oldNW: [],
      oldGW: [],
      oldSchQ: [],
      rgl: {
        idx: -1,
        id: -1,
        rglFileName: '',
        status: '',
        schDate: null,
        supplier: '',
        brand: '',
        intnlRef: '',
        item: '',
        itemDesc: '',
        schQ: '',
        schSeq: '',
        length: '',
        width: '',
        height: '',
        carton: '',
        nw: '',
        gw: '',
        volumn: '',
        soldTo: '',
        deliveryAddr: '',
        incotermCity: '',
        container: '',
        // freightCost: '',
        // freightForwName: '',
        // currency: '',
        // approval: true,
        // packingListNbr: '',
        // etd: null,
        // eta: null,
        flag: 'view'
      },
      index: 0,
      currRglName: '',
      srf: '',
      comment: '',
      cbmNoPrecise: 0,
      rglTbl: {
        rglFileName: '',
        mergedSoldTo: '',
        srf: '',
        netCbm: 0,
        grossCbm: 0,
        freightCost: '',
        freightForwName: '',
        palletNum: '',
        cartonsNoPallet: '',
        currency: '',
        approval: true,
        approvalDate: null,
        shipOut: false,
        packingListNbr: '',
        finalDeliveryAddr: '',
        finalIncotermCity: '',
        etd: null,
        eta: null,
        cargoReadyDate: null,
        SRFAppDate: null,
        comment: '',
        flag: 'view',
        container: ''
      },
      brandList: [],
      selectedIncotermCity: [],
      selectedDeliveryAddress: [],
      dialogFormVisible: false,
      brandParam: {
        userName: '',
        userType: ''
      },
      finalDeliveryAddrList: [],
      finalIncotermCityList: [],
      deliveryAddrList: [],
      incotermCityList: [],
      incotermTownList: []
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    // console.log('this.userName 222 === ' + this.userName)
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getRglData()
    // this.getRglFileList()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getRglFileNames()
    this.getPackingList()
    this.getBrands()
    this.getDeliveryAddrList()
    this.getIncotermCityList()
  },
  methods: {
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    // async getRglDeliveryAddrList () {
    //   const { data: res } = await this.$http.get('/customer/getRglDeliveryAddrList', { params: { value: value } })
    // },
    async getRglFileNames () {
      const { data: res } = await this.$http.get('/show/getRglFileNames')
      this.fglFileNameSelection = await res.rglFileNames
    },
    async getRglData () {
      this.rglData = []
      var finalDeliveryAddrStr = ''
      var finalIncotermCityStr = ''

      if (this.formInline.finalDeliveryAddr && this.formInline.finalDeliveryAddr.length) {
        this.formInline.finalDeliveryAddr = [...this.formInline.finalDeliveryAddr].join(',')
        finalDeliveryAddrStr = this.formInline.finalDeliveryAddr
      }
      if (this.formInline.finalIncotermCity && this.formInline.finalIncotermCity.length) {
        this.formInline.finalIncotermCity = [...this.formInline.finalIncotermCity].join(',')
        finalIncotermCityStr = this.formInline.finalIncotermCity
      }

      // console.log('userName === ' + this.userName)
      if (this.userName.toUpperCase() !== 'J3P') {
        this.formInline.shipOut = 'All'
      }
      const { data: res } = await this.$http.get('/show/getRglTblData', { params: this.formInline })
      var cbm = res.cbmList
      var containList = res.containList
      // console.log('cbm === ' + cbm)
      this.netCbm = Math.round(cbm * 100) / 100
      this.grossCbm = Math.round(cbm * 1.18 * 100) / 100

      if (finalDeliveryAddrStr !== '') {
        await this.$set(this.formInline, 'finalDeliveryAddr', finalDeliveryAddrStr.split(','))
      }
      if (finalIncotermCityStr !== '') {
        await this.$set(this.formInline, 'finalIncotermCity', finalIncotermCityStr.split(','))
      }

      // this.rglData = await res.rglData
      if (res.rglData !== null && res.rglData.length > 0) {
        for (var i = 0; i < res.rglData.length; i++) {
          var approvaled = ''
          // console.log('res.rglData[i].approval === ' + res.rglData[i].approval)
          if (res.rglData[i].approval === '1') {
            // console.log('yesssssssssssssss')
            approvaled = 'Yes'
          } else {
            // console.log('Nooooooooooooooooooooooo')
            approvaled = 'No'
          }

          var shipOut = ''
          if (res.rglData[i].ship_out === '1') {
            shipOut = 'Yes'
          }
          if (res.rglData[i].ship_out === '0') {
            shipOut = 'No'
          }

          var container = ''
          for (var jj = 0; jj < containList.length; jj++) {
            if (res.rglData[i].rglfileName === containList[jj].cargo_id) {
              container = containList[jj].container
              /* if (container !== null && container !== '') {
                shipOut = 'Yes'
              } */
              break
            }
          }

          var theNetCbm = 0
          var theGrossCbm = 0
          var rglFileName = res.rglData[i].rglfileName
          for (var j = 0; j < res.cbmList.length; j++) {
            if (res.cbmList[j].rglfile_name === rglFileName) {
              theNetCbm = Math.round(res.cbmList[j].netCbm * 100) / 100
              theGrossCbm = Math.round(res.cbmList[j].netCbm * 1.18 * 100) / 100
              break
            }
          }
          // console.log('res.rglData[i].cargo_ready_date === ' + res.rglData[i].cargo_ready_date)
          console.log('res.rglData[i].etd 1=== ' + theNetCbm)
          console.log('res.rglData[i].etd 11=== ' + theGrossCbm)
          this.rglTbl = { rglFileName: res.rglData[i].rglfileName, mergedSoldTo: res.rglData[i].merged_soldTo, srf: res.rglData[i].srf, netCbm: theNetCbm, grossCbm: theGrossCbm, freightCost: res.rglData[i].freightCost, freightForwName: res.rglData[i].freightForwName, palletNum: res.rglData[i].pallet_num, cartonsNoPallet: res.rglData[i].cartons_no_pallet, currency: res.rglData[i].currency, approval: approvaled, approvalDate: res.rglData[i].approval_date, shipOut: shipOut, etd: res.rglData[i].etd, packingListNbr: res.rglData[i].packingListNbr, eta: res.rglData[i].eta, finalDeliveryAddr: res.rglData[i].final_delivery_addr, finalIncotermCity: res.rglData[i].final_incoterm_city, cargoReadyDate: res.rglData[i].cargo_ready_date, SRFAppDate: res.rglData[i].srf_app_date, comment: res.rglData[i].comment, flag: 'view', container: container }
          this.rglData.push(this.rglTbl)
          this.rglData = this.rglData.slice(0, 300)
          // console.log('res.rglData.length === ' + this.rglData.length)
        }
      }
    },
    approvalChange (row, idx) {
      console.log('row111 === ' + row.approval)
      console.log('row.$index === ' + idx)

      if (row.approval) {
        this.rglData[idx].approvalDate = new Date()
        this.isDisabled[idx] = false
      } else {
        this.rglData[idx].approvalDate = null
        this.isDisabled[idx] = true
      }

      /* if (value) {
        for (var i = 0; i < this.rglData.length; i++) {
          this.rglData[row.$index].approvalDate = new Date()
          this.isDisabled[row.$index] = false
        }
      } else {
        for (i = 0; i < this.rglData.length; i++) {
          this.rglData[i].approvalDate = null
          this.isDisabled[i] = true
        }
      } */
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log('row.rowIndex === ' + this.multipleSelection.length)
      // console.log('columnIndex === ' + columnIndex)
      if ((columnIndex >= 19 && columnIndex !== 26) && rowIndex === 0) {
        return {
          rowspan: this.multipleSelection.length,
          colspan: 1
        }
      }
      if (rowIndex >= 1 && (columnIndex >= 19 && columnIndex !== 26)) {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    },
    onSubmit () {
      console.log('submit!')
      this.multipleSelection = []
      this.formInline.page = 1
      this.getRglData()
      // this.getRglFileList()
      // this.currRglName = this.formInline.fglFileName
    },
    onSubmitIP () {
      console.log('submit!')
      this.multipleSelection = []
      this.formInline.page = 1
      this.getRglData()
      // this.getRglFileList()
      // this.currRglName = this.formInline.fglFileName
    },
    exportToExcel () {
      // this.getDateRangeStr()
      /* 表示在当前页面打开新地址https://www.myirequest.com */
      if (this.userName.toUpperCase() !== 'J3P') {
        this.formInline.shipOut = 'All'
      }
      window.open('https://www.myirequest.com:8081/show/exportRglFile?rglFileName=' + this.formInline.rglFileName +
      '&item=' + this.formInline.item + '&description=' + this.formInline.description + '&srf=' + this.formInline.srf +
      '&finalDeliveryAddr=' + this.formInline.finalDeliveryAddr + '&finalIncotermCity=' + this.formInline.finalIncotermCity +
      '&customerCode=' + this.formInline.customerCode + '&approved=' + this.formInline.approved + '&shipOut=' + this.formInline.shipOut + '&token=' + encodeURIComponent(this.formInline.token),
      '_parent')
    },
    async getRglFileList (rglFileName) {
      this.multipleSelection = []
      this.netCbm = 0
      this.totalCarton = 0
      this.totalGW = 0
      this.totalNW = 0
      this.totalSchQ = 0
      // const { data: res } = await this.$http.get('/show/readygoodsList', { params: this.formInline })
      const { data: res } = await this.$http.get('/show/rfqForwarderList', { params: { rglFileName: rglFileName } })
      this.fglFileNameList = res.rows
      if (res.rows !== null && res.rows.length > 0) {
        for (var i = 0; i < res.rows.length; i++) {
          this.netCbm = this.netCbm + res.rows[i].volumn
          this.totalCarton += Number(res.rows[i].carton)
          this.totalNW += res.rows[i].nw
          this.totalGW += res.rows[i].gw
          this.totalSchQ += Number(res.rows[i].schQ)
          this.rgl = { idx: this.index, id: res.rows[i].id, rglFileName: res.rows[i].rglfileName, status: res.rows[i].status, schDate: res.rows[i].schDate, schSeq: res.rows[i].schSeq, supplier: res.rows[i].supplier, brand: res.rows[i].brand, intnlRef: res.rows[i].intnlRef, item: res.rows[i].item, itemDesc: res.rows[i].itemDesc, schQ: res.rows[i].schQ, length: res.rows[i].length, width: res.rows[i].width, height: res.rows[i].height, carton: res.rows[i].carton, nw: res.rows[i].nw, gw: res.rows[i].gw, volumn: res.rows[i].volumn, soldTo: res.rows[i].soldTo, deliveryAddr: res.rows[i].deliveryAddr, incotermCity: res.rows[i].incotermCity, flag: 'view' }
          this.multipleSelection.push(this.rgl)
          // , freightCost: res.rows[i].freightCost, freightForwName: res.rows[i].freightForwName, palletNum: res.rows[i].palletNum, currency: res.rows[i].currency, approval: approvaled, etd: res.rows[i].etd, packingListNbr: res.rows[i].packingListNbr, eta: res.rows[i].eta
          this.index++
        }
        var cbm = this.netCbm
        this.cbmNoPrecise = this.netCbm
        this.netCbm = Math.round(this.netCbm * 100) / 100
        this.grossCbm = Math.round(cbm * 1.18 * 100) / 100
      }
      // this.total = res.total
    },
    addRfqRow () {
      this.operation = 'add'
      if (this.multipleSelection.length === 0) {
        return
      }
      // var length = this.multipleSelection.length
      this.rgl = { idx: this.index, id: -1, rglFileName: this.currRglName, status: '', schDate: null, supplier: '', brand: '', intnlRef: '', item: '', itemDesc: '', schQ: '', schSeq: 'Sch. 1', length: '', width: '', height: '', carton: '', nw: '', gw: '', volumn: '', soldTo: '', deliveryAddr: '', incotermCity: '', freightCost: '', freightForwName: '', palletNum: '', currency: '', approval: true, approvalDate: null, packingListNbr: '', cargoReadyDate: null, SRFAppDate: null, etd: null, eta: null, flag: 'add' }
      this.multipleSelection.push(this.rgl)
      this.index++
    },
    async getPackingList () {
      const { data: res } = await this.$http.get('/show/getPackingList')
      this.packingList = await res.plnList
    },
    // async getFinalDeliveryAddrList () {
    //   const { data: res } = await this.$http.get('/show/getFinalList', { params: { value: value } })
    //   this.deliveryAddrList = await res.plnList
    // },
    // async getFinalIncotermCityList () {
    //   const { data: res } = await this.$http.get('/show/getPackingList', { params: { value: value } })
    //   this.packingList = await res.plnList
    // },
    // confirmAdd (value) {
    //   // Vue.prototype.$http = axios
    //   const { data: res } = await this.$http.get('/show/rfqForwarderList', { params: this.formInline })
    //   const that = this
    //   this.$http.get('/show/rfqForwarderSaveOne', { params: row })
    //     .then(res => {
    //       that.getTimelines()

    //       that.$message({
    //         message: '添加成功',
    //         type: 'success',
    //         duration: 500
    //       })
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       that.$message({
    //         message: '添加失败',
    //         type: 'error'
    //       })
    //     })
    // },
    async categoryIncormtownList () {
      const { data: res } = await this.$http.get('/show/categoryIncormtownList')
      this.incotermTownList = await res.incotermTownList
    },
    async addRfqRow2Db (row) {
      const that = this
      this.$confirm('Are you sure you want to add this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        // await that.confirmAdd(value)
        const { data: res } = await that.$http.post('/show/rfqForwarderSaveOne', { params: row })
        row.id = res.id
        // var cbm = this.netCbm + row.volumn
        this.cbmNoPrecise = this.cbmNoPrecise + Number(row.volumn)
        this.totalCarton += Number(row.carton)
        this.totalNW += Number(row.nw)
        this.totalGW += Number(row.gw)
        this.totalSchQ += Number(row.schQ)
        this.netCbm = Math.round(this.cbmNoPrecise * 100) / 100
        this.grossCbm = Math.round(this.cbmNoPrecise * 1.18 * 100) / 100
        for (var i = 0; i < this.rglData.length; i++) {
          if (this.rglData[i].rglFileName === row.rglFileName) {
            this.rglData[i].netCbm = this.netCbm
            this.rglData[i].grossCbm = this.grossCbm
            break
          }
        }
        if (row.approval === true) {
          row.approval = 'Yes'
        } else {
          row.approval = 'No'
        }
        row.flag = 'view'
      }).catch(() => {
      })
    },
    async editRfqTblRow (row, idx) {
      row.flag = 'edit'
      if (row.approval === 'Yes') {
        row.approval = true
      } else {
        row.approval = false
      }
      console.log('new Date() === ' + new Date())
      if (row.approval) {
        // this.rglData[idx].approvalDate = new Date()
        if (row.approvalDate !== null && row.approvalDate !== '') {
          this.rglData[idx].approvalDate = new Date(row.approvalDate)
        }
        this.isDisabled[idx] = false
      } else {
        this.rglData[idx].approvalDate = null
        this.isDisabled[idx] = true
      }
      // if (this.rglData[0].etd === undefined) {
      //   this.rglData[0].etd = null
      // }
      // if (this.rglData[0].eta === undefined) {
      //   this.rglData[0].eta = null
      // }
      if (row.cargoReadyDate !== undefined && row.cargoReadyDate !== null) {
        var yyyy = row.cargoReadyDate.substr(0, 4)
        var mm = row.cargoReadyDate.substr(5, 2)
        var dd = row.cargoReadyDate.substr(8, 2)
        row.cargoReadyDate = yyyy + '-' + mm + '-' + dd
      }
      if (row.SRFAppDate !== undefined && row.SRFAppDate !== null) {
        yyyy = row.SRFAppDate.substr(0, 4)
        mm = row.SRFAppDate.substr(5, 2)
        dd = row.SRFAppDate.substr(8, 2)
        row.SRFAppDate = yyyy + '-' + mm + '-' + dd
      }
      if (row.etd !== undefined && row.etd !== null) {
        yyyy = row.etd.substr(0, 4)
        mm = row.etd.substr(5, 2)
        dd = row.etd.substr(8, 2)
        row.etd = yyyy + '-' + mm + '-' + dd
      }
      if (row.eta !== undefined && row.eta !== null) {
        yyyy = row.eta.substr(0, 4)
        mm = row.eta.substr(5, 2)
        dd = row.eta.substr(8, 2)
        row.eta = yyyy + '-' + mm + '-' + dd
      }
      const { data: res } = await this.$http.post('/show/getFinalDeliveryAddrList', { params: { rglFileName: row.rglFileName } })
      this.finalDeliveryAddrList = res.finalDeviveryAddrList
      const { data: res1 } = await this.$http.post('/show/getFinalIncotermCityList', { params: { rglFileName: row.rglFileName } })
      this.finalIncotermCityList = res1.finalIncotermCityList
      // for (var i = 0; i < this.multipleSelection.length; i++) {
      //   if (value === this.multipleSelection[i].id) {
      //     this.multipleSelection[i].flag = 'edit'
      //     if (this.multipleSelection[i].etd !== null) {
      //       var yyyy = this.multipleSelection[i].etd.substr(0, 4)
      //       var mm = this.multipleSelection[i].etd.substr(5, 2)
      //       var dd = this.multipleSelection[i].etd.substr(8, 2)
      //       this.multipleSelection[i].etd = yyyy + '-' + mm + '-' + dd
      //     }
      //     if (this.multipleSelection[i].eta !== null) {
      //       yyyy = this.multipleSelection[i].eta.substr(0, 4)
      //       mm = this.multipleSelection[i].eta.substr(5, 2)
      //       dd = this.multipleSelection[i].eta.substr(8, 2)
      //       this.multipleSelection[i].eta = yyyy + '-' + mm + '-' + dd
      //     }
      //     if (this.multipleSelection[i].schDate1 !== null) {
      //       var yyyy = this.multipleSelection[i].schDate1.substr(0, 4)
      //       var mm = this.multipleSelection[i].schDate1.substr(5, 2)
      //       var dd = this.multipleSelection[i].schDate1.substr(8, 2)
      //       this.multipleSelection[i].schDate1 = yyyy + '-' + mm + '-' + dd
      //     }
      //     this.oldVolumn[i] = this.multipleSelection[i].volumn
      //   }
    },
    // editDialogClosed () {
    //   this.$refs.brandOpenform.resetFields()
    // },
    viewRfqFile (value, srf, comment) {
      this.operation = 'edit'
      this.currRglName = value
      this.srf = srf
      this.comment = comment
      this.dialogFormVisible = true
      this.getRglFileList(value)
    },
    editRfqRow (value) {
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (value === this.multipleSelection[i].id) {
          this.multipleSelection[i].flag = 'edit'
          // if (this.multipleSelection[i].etd !== null) {
          //   var yyyy = this.multipleSelection[i].etd.substr(0, 4)
          //   var mm = this.multipleSelection[i].etd.substr(5, 2)
          //   var dd = this.multipleSelection[i].etd.substr(8, 2)
          //   this.multipleSelection[i].etd = yyyy + '-' + mm + '-' + dd
          // }
          // if (this.multipleSelection[i].eta !== null) {
          //   yyyy = this.multipleSelection[i].eta.substr(0, 4)
          //   mm = this.multipleSelection[i].eta.substr(5, 2)
          //   dd = this.multipleSelection[i].eta.substr(8, 2)
          //   this.multipleSelection[i].eta = yyyy + '-' + mm + '-' + ddgong
          // }
          if (this.multipleSelection[i].schDate !== null) {
            var yyyy = this.multipleSelection[i].schDate.substr(0, 4)
            var mm = this.multipleSelection[i].schDate.substr(5, 2)
            var dd = this.multipleSelection[i].schDate.substr(8, 2)
            this.multipleSelection[i].schDate = yyyy + '-' + mm + '-' + dd
          }
          this.oldVolumn[i] = this.multipleSelection[i].volumn
          this.oldCarton[i] = this.multipleSelection[i].carton
          this.oldNW[i] = this.multipleSelection[i].nw
          this.oldGW[i] = this.multipleSelection[i].gw
          this.oldSchQ[i] = this.multipleSelection[i].schQ
          // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
        }
      }
    },
    async getDeliveryAddrList () {
      const { data: res } = await this.$http.get('/show/deliveryAddrList', { params: this.brandParam })
      this.deliveryAddrList = await res.deliveryAddr
      console.log('this.deliveryAddrList.length === ' + this.deliveryAddrList.length)
      if (this.deliveryAddrList.indexOf('IP dayton') === -1) {
        this.deliveryAddrList.push('IP dayton')
      }
    },
    async getIncotermCityList () {
      const { data: res } = await this.$http.get('/show/incotermCityList', { params: this.brandParam })
      this.incotermCityList = await res.incotermCityList
      if (this.incotermCityList.indexOf('SHA') === -1) {
        this.incotermCityList.push('SHA')
      }
      if (this.incotermCityList.indexOf('SZ') === -1) {
        this.incotermCityList.push('SZ')
      }
    },
    updateRfqTblRow2Db (row) {
      const that = this
      this.$confirm('Are you sure you want to update this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        // await that.confirmAdd(value)
        // console.log('row.cargoReadyDate === ' + row.cargoReadyDate)
        // console.log('row.etd === ' + row.etd)
        await that.$http.post('/show/rfqForwarderTblUpdate', { params: row })
        // var cbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        // this.netCbm = Math.round(cbm * 100) / 100
        // this.grossCbm = Math.round(cbm * 1.3 * 100) / 100
        if (row.approval === true) {
          row.approval = 'Yes'
        } else {
          row.approval = 'No'
        }
        if (row.shipOut === true) {
          row.shipOut = 'Yes'
        } else {
          row.shipOut = 'No'
        }
        // this.netCbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        row.flag = 'view'
        // for (var i = 0; i < this.multipleSelection.length; i++) {
        //   console.log(this.multipleSelection[i].id + ',' + this.multipleSelection[i].flag)
        // }
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    updateRfqRow2Db (row) {
      const that = this
      this.$confirm('Are you sure you want to update this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        // await that.confirmAdd(value)
        await that.$http.post('/show/rfqForwarderUpdateOne', { params: row })
        this.cbmNoPrecise = this.cbmNoPrecise - Number(this.oldVolumn[row.idx]) + Number(row.volumn)
        this.totalCarton = this.totalCarton - Number(this.oldCarton[row.idx]) + Number(row.carton)
        this.totalNW = this.totalNW - Number(this.oldNW[row.idx]) + Number(row.nw)
        this.totalGW = this.totalGW - Number(this.oldGW[row.idx]) + Number(row.gw)
        this.totalSchQ = this.totalSchQ - Number(this.oldSchQ[row.idx]) + Number(row.schQ)
        // var cbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        this.netCbm = Math.round(this.cbmNoPrecise * 100) / 100
        this.grossCbm = Math.round(this.cbmNoPrecise * 1.18 * 100) / 100
        for (var i = 0; i < this.rglData.length; i++) {
          if (this.rglData[i].rglFileName === row.rglFileName) {
            this.rglData[i].netCbm = this.netCbm
            this.rglData[i].grossCbm = this.grossCbm
            break
          }
        }
        if (row.approval === true) {
          row.approval = 'Yes'
        } else {
          row.approval = 'No'
        }
        // if (row.shipOut === true) {
        //   row.shipOut = 'Yes'
        // } else {
        //   row.shipOut = 'No'
        // }
        // this.netCbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        // row.id = res.id
        row.flag = 'view'
        // for (var i = 0; i < this.multipleSelection.length; i++) {
        //   console.log(this.multipleSelection[i].id + ',' + this.multipleSelection[i].flag)
        // }
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    delRfqRow (value) {
      if (this.multipleSelection.length === 1) return
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (value === this.multipleSelection[i].idx) {
          this.multipleSelection.splice(i, 1)
          // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
        }
      }
    },
    confirmDelete (row) {
      // Vue.prototype.$http = axios
      const that = this
      // console.log('row.id === 111' + row.id)
      this.$http.get('/show/delRfg', { params: { value: row.id } })
        .then(res => {
          row.id = res.id
          row.flag = 'view'
          for (var i = 0; i < this.multipleSelection.length; i++) {
            if (row.idx === this.multipleSelection[i].idx) {
              this.multipleSelection.splice(i, 1)
              // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
            }
          }
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    rfqTblConfirmDelete (rglFileName) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/show/deleteRfgFile', { params: { value: rglFileName } })
        .then(res => {
          // row.id = res.id
          // row.flag = 'view'
          // for (var i = 0; i < this.multipleSelection.length; i++) {
          //   if (row.idx === this.multipleSelection[i].idx) {
          //     this.multipleSelection.splice(i, 1)
          //     // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
          //   }
          // }
          this.rglData = []
          this.multipleSelection = []
          this.netCbm = 0
          this.grossCbm = 0
          this.getRglData()
          this.getRglFileNames()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    delRfqTbl2Db (rglFileName) {
      // console.log('currRglName === ' + this.currRglName)
      if (rglFileName === null || rglFileName === '') {
        return
      }
      const that = this
      this.$confirm('This will permanently delete the RGL File. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.rfqTblConfirmDelete(rglFileName)
        // this.netCbm = this.netCbm - row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
      this.getRglData()
    },
    async delRfqRow2Db (row) {
      if (this.multipleSelection.length === 1) return
      if (row.id === -1) {
        if (this.multipleSelection.length === 1) return
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (row.idx === this.multipleSelection[i].idx) {
            this.multipleSelection.splice(i, 1)
            // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
          }
        }
        return
      }
      const that = this
      const { data: res } = await this.$http.get('/show/getCBMbyId', { params: { value: row.id } })
      this.$confirm('This will permanently delete the item. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(row)
        this.cbmNoPrecise = this.cbmNoPrecise - Number(res.values.volumn)
        this.totalCarton = this.totalCarton - Number(res.values.carton)
        this.totalNW = this.totalNW - Number(res.values.nw)
        this.totalGW = this.totalGW - Number(res.values.gw)
        this.totalSchQ = this.totalSchQ - Number(res.values.schQ)
        this.netCbm = Math.round(this.cbmNoPrecise * 100) / 100
        this.grossCbm = Math.round(this.cbmNoPrecise * 1.18 * 100) / 100
        for (var i = 0; i < this.rglData.length; i++) {
          if (this.rglData[i].rglFileName === row.rglFileName) {
            this.rglData[i].netCbm = this.netCbm
            this.rglData[i].grossCbm = this.grossCbm
            break
          }
        }
      }).catch(() => {
      })
    },
    checkInteger (e) {
      if (e.target.value === null || e.target.value === '') {
        return
      }
      if (!(/(^[1-9]\d*$)/.test(e.target.value))) {
      // if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER or leave blank', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      }
    },
    checkNum (e) {
      // const that = this
      // console.log('event.target.value === ' + e.target.value)
      if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER or leave blank', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      }
    },
    async checkItemNumber (e) {
      // console.log(e)
      const { data: res } = await this.$http.get('/show/getItemInfobyItem', { params: { value: e.target.value.trim() } })
      var result = res.result
      var brand = result.brand
      // var customerCode = ''
      // for (var i = 0; i < this.customerBrands.length; i++) {
      //   var brandArr = this.customerBrands[i].brandCode
      //   if (brandArr.indexOf(brand) >= 0) {
      //     customerCode = this.customerBrands[i].customerCode
      //     break
      //   }
      // }
      var rowId = e.target.dataset.id
      // console.log('currRglName === ' + this.currRglName)
      // console.log('this.multipleSelection[rowId].rglFileName === ' + this.multipleSelection[rowId].rglFileName)
      // const { data: res1 } = await this.$http.get('/show/getCustomerCodeByRglFileName', { params: { value: this.currRglName } })

      for (var j = 0; j < this.multipleSelection.length; j++) {
        if (Number(rowId) === Number(this.multipleSelection[j].idx)) {
          this.multipleSelection[j].itemDesc = result.item_desc
          this.multipleSelection[j].brand = brand
          this.multipleSelection[j].length = result.pck_length
          this.multipleSelection[j].width = result.pck_width
          this.multipleSelection[j].height = result.pck_height
        }
      }

      // for (var j = 0; j < this.multipleSelection.length; j++) {
      //   if (Number(rowId) === Number(this.multipleSelection[j].idx)) {
      //     this.multipleSelection[j].itemDesc = result.item_desc
      //     this.multipleSelection[j].brand = brand
      //     this.multipleSelection[j].length = result.pck_length
      //     this.multipleSelection[j].width = result.pck_width
      //     this.multipleSelection[j].height = result.pck_height
      //   }
      // }

      // if (customerCode === '' || customerCode !== res1.customerCode) {
      //   this.$alert('The Item Number is incorrect. Please check.', 'Warning', {
      //     confirmButtonText: 'Ok',
      //     callback: action => {
      //       e.target.focus()
      //     }
      //   })
      // } else {
      //   for (var j = 0; j < this.multipleSelection.length; j++) {
      //     if (Number(rowId) === Number(this.multipleSelection[j].idx)) {
      //       this.multipleSelection[j].itemDesc = result.item_desc
      //       this.multipleSelection[j].brand = brand
      //       this.multipleSelection[j].length = result.pck_length
      //       this.multipleSelection[j].width = result.pck_width
      //       this.multipleSelection[j].height = result.pck_height
      //     }
      //   }
      // }
    },
    async getBrandbyItem (e) {
      const { data: res } = await this.$http.get('/show/getBrandbyItem', { params: { value: e.target.value.trim() } })
      var brand = res.brand
      this.rgl.brand = brand
      // var customerCode = ''
      // for (var i = 0; i < this.customerBrands.length; i++) {
      //   var brandArr = this.customerBrands[i].brandCode
      //   if (brandArr.indexOf(brand) >= 0) {
      //     customerCode = this.customerBrands[i].customerCode
      //     break
      //   }
      // }
      // if (customerCode === '' || customerCode !== this.currCustomerCode) {
      //   this.$alert('The Item Number is incorrect. Please check.', 'Warning', {
      //     confirmButtonText: 'Ok',
      //     callback: action => {
      //       // this.$message({
      //       //   type: 'info',
      //       //   message: 'aaa'
      //       // })
      //       e.target.focus()
      //     }
      //   })
      // } else {
      //   this.rgl.brand = brand
      // }
    },
    numFormat (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      if (numrc.toString().indexOf('.') === -1) {
        return numrc
      }
      var result = ''
      var numrcStr = numrc.toString()
      numrc = numrcStr.substring(0, numrcStr.indexOf('.') + 3)
      return result
    },
    zeroFormat (numrc) {
      if (numrc === null || numrc === '' || Number(numrc) === Number(0)) {
        return
      }
      return numrc
    },
    dateFormat1 (daterc) {
      // const daterc = row[column.property]
      if (daterc === undefined || daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getRglData()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getRglData()
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    }

  }
}
</script>

<style lang="less" scoped="scoped">
  .div-class1 {
    border:solid 1px #000;
    margin-bottom: 15px;
    padding-top:10px;
    // line-height: 50px;
  }
</style>
